import { GenericObject } from "utility/misc";

export default function redirectToWebexWebhookConnectPage(
  orgStore: GenericObject,
  navigate: Function
): void {
  navigate("/environment/destinations/webex_webhook/connect");
}
